<template>
    <form @submit.prevent="$emit('resetList', {})">
        <div class="row mb-0 rooms-advanced-search">
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="Building:" class="modal-label" v-html="'Building:'"/>
                    <select size="" class="input-field custom-select" v-model="form_data.building_id">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(item, i) in array_options.building_id" :key="i" :value="item.id" v-html="item.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="Level:" class="modal-label" v-html="'Level:'"/>
                    <select size="" class="input-field custom-select" v-model="form_data.level_id">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(item, i) in array_options.level_id" :key="i" :value="item.id" v-html="item.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="Area:" class="modal-label" v-html="'Area:'"/>
                    <select size="" class="input-field custom-select" v-model="form_data.area_id">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(item, i) in array_options.area_id" :key="i" :value="item.id" v-html="item.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="Description:" class="modal-label" v-html="'Description:'"/>
                    <input  type="text" v-on:input="$emit('debounceInput', {value: $event.target.value, field:'description'})">
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="customdescription?:" class="modal-label" v-html="'Custom Description:'"/>
                    <select size="" class="input-field custom-select" v-model="form_data.custom_description">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(item, i) in boolean_options" :key="i" :value="item.id" v-html="item.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="seconddescription?:" class="modal-label" v-html="'Second Description:'"/>
                    <select size="" class="input-field custom-select" v-model="form_data.second_description">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(item, i) in boolean_options" :key="i" :value="item.id" v-html="item.name"/>
                    </select>
                </div>
            </div>
        
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="Room type:" class="modal-label" v-html="'Room type:'"/>
                    <select size="" class="input-field custom-select" v-model="form_data.room_type_id">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(item, i) in array_options.room_type_id" :key="i" :value="item.id" v-html="item.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="Floor Type:" class="modal-label" v-html="'Floor type:'"/>
                    <select size="" class="input-field custom-select" v-model="form_data.floor_id">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(item, i) in array_options.floor_id" :key="i" :value="item.id" v-html="item.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="CostCenter:" class="modal-label" v-html="'Cost center:'"/>
                    <select size="" class="input-field custom-select" v-model="form_data.cost_center_id">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(item, i) in array_options.cost_center_id" :key="i" :value="item.id" v-html="item.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="Open?:" class="modal-label" v-html="'Closed?:'"/>
                    <select size="" class="input-field custom-select" v-model="form_data.closed">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(item, i) in boolean_options" :key="i" :value="item.id" v-html="item.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for=":" class="modal-label" v-html="'Door Number:'"/>
                    <input type="text" v-on:input="$emit('debounceInput', {value: $event.target.value, field:'door_number'})">
                </div>
            </div>
            <div class="formdynamic__item col-md-2 pl-2 py-0">
                <div class="row mb-0">
                    <div class="col-md-3 py-0">
                        <div class="formdynamic__item__field">
                            <label for="Fixtures/Beds:" class="modal-label" v-html="'Fixtures/Beds:'"/>
                            <select size="" class="input-field custom-select" v-model="form_data.fixture_simbol">
                                <!-- <option value="" v-html="'Select an option'"/> -->
                                <option v-for="(item, i) in simbol_options" :key="i" :value="item.id" v-html="item.name"/>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-9 py-0">
                        <div class="formdynamic__item__field">
                            <label class="modal-label invisible" v-html="'Fixtures/Beds:'"/>
                            <input type="number" :min="0" class="form-control" v-on:input="$emit('debounceInput', {value: $event.target.value, field:'fixtures'})"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 pl-2 py-0">
                <div class="row mb-0">
                    <div class="col-md-3 py-0">
                        <div class="formdynamic__item__field">
                            <label for="SQ/FT:" class="modal-label" v-html="'SQ/FT:'"/>
                            <select size="" class="input-field custom-select" v-model="form_data.sq_ft_simbol">
                                <option v-for="(item, i) in simbol_options" :key="i" :value="item.id" v-html="item.name"/>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-9 py-0">
                        <div class="formdynamic__item__field">
                            <label class="modal-label invisible" v-html="'SQ/FT:'"/>
                            <input type="number" :min="0" class="form-control" v-on:input="$emit('debounceInput', {value: $event.target.value, field:'sq_ft'})"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="essential_cleaning:" class="modal-label" v-html="'Essential cleaning:'"/>
                    <select size="" class="input-field custom-select" v-model="form_data.essential_cleaning">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(item, i) in boolean_options" :key="i" :value="item.id" v-html="item.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="WorkGroup" class="modal-label" v-html="'Work Group:'"/>
                    <select size="" class="input-field custom-select" v-model="form_data.work_group">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(item, i) in array_options.group_id" :key="i" :value="item.id" v-html="item.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="Excl. Dailys" class="modal-label" v-html="'Excl. Dailys:'"/>
                    <select size="" class="input-field custom-select" v-model="form_data.exclude_daily">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(item, i) in excl_options" :key="i" :value="item.id" v-html="item.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="Excl. Projects" class="modal-label" v-html="'Excl. Projects:'"/>
                    <select size="" class="input-field custom-select" v-model="form_data.exclude_project">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(item, i) in excl_options" :key="i" :value="item.id" v-html="item.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="PatientRoom:" class="modal-label" v-html="'Patient room:'"/>
                    <select size="" class="input-field custom-select" v-model="form_data.patient">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(item, i) in boolean_options" :key="i" :value="item.id" v-html="item.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="Comment:" class="modal-label" v-html="'Comment:'"/>
                    <input type="text" v-on:input="$emit('debounceInput', {value: $event.target.value, field:'notes'})"/>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="Disable Daily Updates" class="modal-label" v-html="'Disable Daily Updates:'"/>
                    <select size="" class="input-field custom-select" v-model="form_data.disabled_daily">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(item, i) in boolean_options" :key="i" :value="item.id" v-html="item.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="Disable Project Updates" class="modal-label" v-html="'Disable Project Updates:'"/>
                    <select size="" class="input-field custom-select" v-model="form_data.disabled_project">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(item, i) in boolean_options" :key="i" :value="item.id" v-html="item.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="Daily Assignment" class="modal-label" v-html="'Daily Assignment:'"/>
                    <select size="" class="input-field custom-select" v-model="form_data.daily_assignment_id">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(item, i) in array_options.daily_assignment_id" :key="i" :value="item.id" v-html="item.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-auto py-0">
                <div class="formdynamic__item__field">
                    <label for="Daily shift:" class="modal-label" v-html="'Daily shift: '"/>
                    <span class="d-flex">
                        <div class="pt-2">
                            <label class="modal-label" v-html="'1'"/>
                            <div class="custom-control custom-checkbox">
                                <input :id="'shift1'" type="checkbox" class="custom-control-input" v-model="form_data.shift1"/>
                                <label :for="'shift1'" class="custom-control-label ml-2"/>
                            </div>
                        </div>
                        <div class="pt-2">
                            <label class="modal-label" v-html="'2'"/>
                            <div class="custom-control custom-checkbox">
                                <input :id="'shift2'" type="checkbox" class="custom-control-input" v-model="form_data.shift2"/>
                                <label :for="'shift2'" class="custom-control-label ml-2"/>
                            </div>
                        </div>
                        <div class="pt-2">
                            <label class="modal-label" v-html="'3'"/>
                            <div class="custom-control custom-checkbox">
                                <input :id="'shift3'" type="checkbox" class="custom-control-input" v-model="form_data.shift3"/>
                                <label :for="'shift3'" class="custom-control-label ml-2"/>
                            </div>
                        </div>
                        <div class="pt-2">
                            <label class="modal-label" v-html="'none'"/>
                            <div class="custom-control custom-checkbox">
                                <input :id="'none'" type="checkbox" class="custom-control-input" v-model="form_data.none"/>
                                <label :for="'none'" class="custom-control-label ml-2"/>
                            </div>
                        </div>
                    </span>
                </div>
            </div>
            <!-- <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="Shift Criteria" class="modal-label" v-html="'Shift Criteria:'"/>
                    <select size="" class="input-field custom-select">
                        <option value="" v-html="'Select an option'"/>
                    </select>
                </div>
            </div> -->
            <div class="formdynamic__item col-md-2 py-0">
                <div class="row mb-0">
                    <div class="col-md-4 py-0">
                        <div class="formdynamic__item__field">
                            <label class="modal-label" v-html="'SinkMin:'"/>
                            <select class="input-field custom-select" v-model="form_data.time_adjustment_simbol">
                                <option v-for="(item, i) in simbol_options" :key="i" :value="item.id" v-html="item.name"/>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-8 py-0">
                        <div class="formdynamic__item__field">
                            <label class="modal-label invisible" v-html="'Sink:'"/>
                            <input type="number" class="form-control" v-on:input="$emit('debounceInput', {value: $event.target.value, field:'time_adjustment'})"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="formdynamic__item col-auto py-0 rooms-advanced-search__radio-tasks">
                <div class="formdynamic__item__field pl-2">
                    <div v-for="(value, i) in radio_options" :key="i" :class="value.div_class">
                        <input 
                            :class="value.input_class"
                            type="radio"
                            :id="value.ref + '-advanced-search'"
                            name="radio"
                            :value="value.ref"
                            v-model="form_data.radio"
                            :checked="i === radio_options.length - 1 ? true : false"
                        />
                        <label :for="value.ref + '-advanced-search'" :class="'form-check-label radiobutton__text custom-control-label'" v-html="value.name"/>
                    </div>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="Task:" class="modal-label" v-html="'Task:'"/>
                    <select size="" class="input-field custom-select" v-model="form_data.task_id" :disabled="form_data.radio && form_data.radio != 'all' ? false : true">
                        <option value="" v-html="'Select an option'" />
                        <option v-for="(item, i) in array_options.task_id" :key="i" :value="item.id" v-html="item.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 pl-2 py-0">
                <div class="row mb-0">
                    <div class="col-md-3 py-0" v-if="form_data.radio != 'projects'">
                        <div class="formdynamic__item__field">
                            <label for="Frequency:" class="modal-label" v-html="'Frequency:'"/>
                            <select size="" class="input-field custom-select" v-model="form_data.freq_simbol" :disabled="form_data.radio && form_data.radio != 'all' ? false : true">
                                <option v-for="(item, i) in simbol_options" :key="i" :value="item.id" v-html="item.name"/>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-9 py-0">
                        <div class="formdynamic__item__field">
                            <label class="modal-label" :class="form_data.radio != 'projects' ? 'invisible' : ''" v-html="'Frequency:'"/>
                            <select size="" class="input-field custom-select" v-model="form_data.frequency" v-if="form_data.radio == 'projects'" :disabled="form_data.radio && form_data.radio != 'all' ? false : true">
                                <option value="" v-html="'Select an option'" />
                                <option v-for="(item, i) in array_options['frequency_id']" :key="i" :value="item.id" v-html="item.name"/>
                            </select>
                            <input v-else type="number" :min="0" class="form-control" :value="form_data['frequency']" v-on:input="$emit('debounceInput', {value: $event.target.value, field:'frequency'})" :disabled="form_data.radio && form_data.radio != 'all' ? false : true"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-3 d-flex align-items-center justify-content-center">
            <button style="width: 220px !important;" class="mx-md-0 modal__buttons__item w-auto h-auto px-3 lh-1 d-flex align-items-center justify-content-center" v-html="'Search'" type="submit"/>
        </div>
    </form>
    
</template>

<script>

export default {

    name: 'LocalFormSearch',

    props:[
        'form_data',
        'array_options',
        'boolean_options',
        'radio_options',
        'simbol_options',
        'excl_options',
    ],

    mounted() 
    {
        window.addEventListener('keydown', this.handleEnterKey);
    },
    beforeDestroy() 
    {
        window.removeEventListener('keydown', this.handleEnterKey);
    },

    methods: {
    handleEnterKey(event) {
      if (event.key === 'Enter') {
        this.$emit('resetList', {})
      }
    },
  }


}

</script>